






















































import { Vue, Component, Inject, Prop, Watch } from "vue-property-decorator";
import i18n from "@/i18n";
import _ from "@/boot/lodash";

// Enums/Data
import { UserMetaKeys } from "@/data/enums/users";
import { ListDisplayMode } from "@/data/constants";

// Types
import { IProduct } from "@/models/products";
import {
  ICatalogueProductListData,
  ICatalogueProductListMethods
} from "@/models/providers/catalogueProducts";

@Component({
  components: {
    "products-view-switcher": () =>
      import(
        "@/components/app/admin/catalogue/products/listing/productsViewSwitcher.vue"
      )
  }
})
export default class ProductsListing extends Vue {
  // Inject - Catalogue product list data

  @Inject({ from: "catalogueProductListData" })
  public readonly $catalogueProductListData!: () => ICatalogueProductListData;

  public get $productListData() {
    return this.$catalogueProductListData();
  }

  // Inject - Catalogue product list methods

  @Inject({ from: "catalogueProductListMethods" })
  public readonly $productListMethods!: ICatalogueProductListMethods;

  // Props

  @Prop({ default: null })
  public selectedProducts!: {
    id: IProduct["id"];
    category_id: IProduct["category_id"];
  }[];

  @Prop({ default: null })
  public disabledProducts!: IProduct["id"][];

  @Prop({ default: false })
  public disableBundles!: boolean;

  @Prop({ default: true })
  public isMultiselect!: boolean;

  @Prop({
    default: () => [
      ListDisplayMode.TABLE,
      ListDisplayMode.TREE,
      ListDisplayMode.GRID
    ]
  })
  public availableModes!: ListDisplayMode[];

  @Prop({ default: i18n.t("_action.manage_product") })
  public action!: boolean;

  @Prop({ required: true })
  public showTreeView!: boolean;

  // Data

  public displayMode = ListDisplayMode.GRID;
  public userMetaKeys = UserMetaKeys;

  // Computed

  public get isTreeView() {
    if (!this.availableModes.includes(ListDisplayMode.TREE)) return false;

    return (
      this.$store.getters["user/meta"](
        UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE
      ) === ListDisplayMode.TREE
    );
  }

  // Watchers

  @Watch("isTreeView")
  public onShowTreeViewChange() {
    if (!this.isTreeView) return;

    this.$productListMethods.getData({
      ...this.$productListData.defaults,
      ignoreStored: true
    });

    this.$emit("refreshTreeView");
  }

  @Watch("$productListData.config.filters")
  public onActiveFiltersChange() {
    // If display mode is TREE and any filters or sort applied => change to GRID or TABLE view

    if (
      this.isTreeView &&
      (!_.isEmpty(this.$productListData.config.filters) ||
        !_.isEqual(
          this.$productListData.config.sort,
          this.$productListData.defaults.sort
        ))
    ) {
      this.$store.dispatch(`user/addMeta`, {
        [UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE]: ListDisplayMode.GRID
      });

      this.displayMode = this.availableModes.includes(ListDisplayMode.GRID)
        ? ListDisplayMode.GRID
        : ListDisplayMode.TABLE;
    }
  }
}
